import { styles } from './view/styles';
import { html, LitElement } from 'lit';
import { customElement, query } from 'lit/decorators.js';
import { InputWidthValues } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';
import { translateFn } from '../../../../../utils/translator.helper';
import { TaskTarget } from '../../../types';
import { GzTimePickerWebComponent } from '../../../../../ui/gzTimePicker';
import { TimePickerEvents } from '../../../../../ui/gzTimePicker/types';
import { NetworkPopUpEvents } from '../../NetworkBasePopUp';
import { ProtectedEntitiesHelper } from '../../../../networkAppContainer/helpers/protectedEntities/protected.entities.helper';
import { WEB_COMPONENT_SUSPEND_INTEGRITY_MONITORING } from '../../../../../webcomponents.constants';

@customElement(WEB_COMPONENT_SUSPEND_INTEGRITY_MONITORING)
export class GzSuspendIntegrityMonitoringWebComponent extends LitElement {
  static get styles() {
    return styles;
  }

  public targets: Array<TaskTarget>;

  @query('#integrity-monitor-pause-duration')
  private timePicker: GzTimePickerWebComponent;

  public duration = 0;

  protected firstUpdated() {
    this.timePicker.addEventListener(TimePickerEvents.CHANGE, this.timeChangedHandler.bind(this));
  }

  private timeChangedHandler(event: CustomEvent) {
    const { hours, minutes } = event.detail.time;

    this.duration = hours * 3600 + minutes * 60;

    this.toggleSaveButtonEnabling();
  }

  private toggleSaveButtonEnabling(): void {
    this.dispatchEvent(
      new CustomEvent(NetworkPopUpEvents.SET_CONFIRM_BUTTON, {
        bubbles: true,
        composed: true,
        detail: { value: this.duration === 0 },
      })
    );
  }

  protected render() {
    const chipList = Application.Main.company.isPartner()
      ? this.targets.map(target => {
          return ProtectedEntitiesHelper.isEndpoint(target)
            ? `${target.name}`
            : `${target.company.name}-${target.name}`;
        })
      : this.targets.map(target => target.name);

    return html`<div class="actions-wrapper">
      <gz-labeled-content
        id="integrity-monitor-pause-targets"
        class="label-mw-250"
        hasFormLabelWidth
        labelFontSize="13"
        label="${translateFn('Targets') + ` (${this.targets.length})`}"
      >
        <gz-chips-generator-input
          gz-form-input
          .chipList="${chipList}"
          ?themeInput="${true}"
          ?hideCopyToClipboardButton="${true}"
          ?allowDuplicates="${true}"
          required
          disabled
        ></gz-chips-generator-input>
      </gz-labeled-content>

      <gz-labeled-content
        id="integrity-monitor-pause-duration-label"
        class="label-mw-250"
        hasFormLabelWidth
        labelFontSize="13"
        label="${translateFn('Duration')}"
      >
        <gz-time-picker
          id="integrity-monitor-pause-duration"
          inputWidth="${InputWidthValues.MEDIUM}"
          hourLabel="${translateFn('hours')}"
          minuteLabel="${translateFn('minutes')}"
        ></gz-time-picker>
      </gz-labeled-content>
    </div>`;
  }
}
